//C:\ViYash\XPRSuvey\XPRSuvey-App\src\Utility\sanitizeHtml.js
import DOMPurify from "dompurify";

/**
 * Sanitizes an HTML string, keeping only safe formatting tags.
 * Use with `dangerouslySetInnerHTML` to render rich-text descriptions.
 */
export const sanitizeHtml = (html) =>
  DOMPurify.sanitize(html || "", {
    ALLOWED_TAGS: [
      "p", "br", "strong", "em", "u", "s",
      "h1", "h2", "h3",
      "ul", "ol", "li",
      "table", "thead", "tbody", "tr", "th", "td", "colgroup", "col",
      "span",
    ],
    ALLOWED_ATTR: ["style", "type"],
  });

/**
 * Strips all HTML tags and returns plain text.
 * Useful for tooltips, truncated previews, input validations, etc.
 */
export const stripHtml = (html) => {
  if (!html) return "";
  const doc = new DOMParser().parseFromString(html, "text/html");
  return (doc.body.textContent || "").trim();
};

/**
 * CSS styles for rendering rich HTML content inside description containers.
 * Inject via a <style> tag or CSS-in-JS.
 */
export const DESCRIPTION_RICH_CONTENT_STYLES = `
  .description-rich-content p { margin: 0.25rem 0; }
  .description-rich-content h1 { font-size: 1.15rem; font-weight: 700; margin: 0.4rem 0; }
  .description-rich-content h2 { font-size: 1rem; font-weight: 700; margin: 0.4rem 0; }
  .description-rich-content h3 { font-size: 0.9rem; font-weight: 600; margin: 0.3rem 0; }
  .description-rich-content ul { list-style: disc; padding-left: 1.25rem; margin: 0.3rem 0; }
  .description-rich-content ol { list-style: decimal; padding-left: 1.25rem; margin: 0.3rem 0; }
  .description-rich-content ol[type="a"] { list-style-type: lower-alpha; }
  .description-rich-content ol[type="A"] { list-style-type: upper-alpha; }
  .description-rich-content li { margin: 0.1rem 0; }
  .description-rich-content table { border-collapse: collapse; width: 100%; margin: 0.4rem 0; table-layout: auto; }
  .description-rich-content td, .description-rich-content th { border: 1px solid #e2e8f0; padding: 4px 8px; text-align: left; }
  .description-rich-content th { background: #f8fafc; font-weight: 600; }
`;
